import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import moment from "moment";
import { EGiftTransaction } from "src/app/shared/models/eGift/EGiftTransaction.model";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";
import * as uuid from "uuid";

@Component({
	selector: "app-e-gift-detail",
	templateUrl: "./e-gift-detail.component.html",
	styleUrls: ["../../gift.style.scss"],
})
export class EGiftDetailComponent implements OnInit {
	@Input() eGiftVenue: EGiftVenue;
	@Output() transactionDetail: EventEmitter<EGiftTransaction> = new EventEmitter<EGiftTransaction>();

	controlRecipientEmail: UntypedFormControl;
	controlRecipientName: UntypedFormControl;
	controlPurchaserEmail: UntypedFormControl;
	controlPurchaserFirstName: UntypedFormControl;
	controlPurchaserLastName: UntypedFormControl;

	for: string = "me";

	moment: any = moment;

	forOptions = [
		{
			label: "For Me!",
			value: "me",
		},
		{
			label: "For a Friend!",
			value: "friend",
		},
	];
	sendDateTime: string;
	sendOptions = [
		{
			label: "Send Now",
			value: false,
		},
		{
			label: "Send Later",
			value: true,
		},
	];

	transaction: EGiftTransaction;

	constructor() {}

	ngOnInit(): void {
		this.transaction = new EGiftTransaction({
			venueKey: this.eGiftVenue.venueKey,
			key: uuid.v4(),
			transactionDateTime: new Date(),
			delaySend: false,
		});

		this.controlRecipientEmail = new UntypedFormControl(this.transaction.recipientEmail, [Validators.email]);
		this.controlPurchaserEmail = new UntypedFormControl(this.transaction.purchaserEmail, [Validators.email, Validators.required]);
		this.controlPurchaserFirstName = new UntypedFormControl(this.transaction.purchaserFirstName, [Validators.required]);
		this.controlPurchaserLastName = new UntypedFormControl(this.transaction.purchaserLastName, [Validators.required]);
		this.controlRecipientName = new UntypedFormControl(this.transaction.recipientName);
	}

	onChange(event) {}

	submitTransaction() {
		if (this.sendDateTime) {
			this.transaction.sendDateTime = moment(this.sendDateTime).toDate();
		}
		this.transactionDetail.emit(this.transaction);
	}
}
